module.exports = __webpack_public_path__ + "static/media/portfolio_title_4.df0722db.svg";